import { jobLists } from "character";
import { EorzeaDataType, GameData, Job, RelicData } from "enums";
import { Info } from "types/game";

export const dtItems = {
	[GameData.Item.AZURITE_DEMIATMA]: {
		name: GameData.Item.AZURITE_DEMIATMA,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			duties: {
				fates: [GameData.MapLocation.OCCULT_SOUTH_HORN, GameData.MapLocation.URQOPACHA],
				trials: [GameData.MapLocation.OCCULT_SOUTH_HORN],
			},
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_PHANTOM, RelicData.Part.WEAPON_PENUMBRAE, RelicData.Step.DEMIATMA, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_PHANTOM],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.VERDIGRIS_DEMIATMA]: {
		name: GameData.Item.VERDIGRIS_DEMIATMA,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			duties: {
				fates: [GameData.MapLocation.OCCULT_SOUTH_HORN, GameData.MapLocation.KOZAMA_UKA],
				trials: [GameData.MapLocation.OCCULT_SOUTH_HORN],
			},
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_PHANTOM, RelicData.Part.WEAPON_PENUMBRAE, RelicData.Step.DEMIATMA, RelicData.Task.TASK_2],
				jobs: jobLists.relic[RelicData.Group.WEAPON_PHANTOM],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.MALACHITE_DEMIATMA]: {
		name: GameData.Item.MALACHITE_DEMIATMA,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			duties: {
				fates: [GameData.MapLocation.OCCULT_SOUTH_HORN, GameData.MapLocation.YAK_TEL],
				trials: [GameData.MapLocation.OCCULT_SOUTH_HORN],
			},
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_PHANTOM, RelicData.Part.WEAPON_PENUMBRAE, RelicData.Step.DEMIATMA, RelicData.Task.TASK_3],
				jobs: jobLists.relic[RelicData.Group.WEAPON_PHANTOM],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.REALGAR_DEMIATMA]: {
		name: GameData.Item.REALGAR_DEMIATMA,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			duties: {
				fates: [GameData.MapLocation.OCCULT_SOUTH_HORN, GameData.MapLocation.SHAALOANI],
				trials: [GameData.MapLocation.OCCULT_SOUTH_HORN],
			},
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_PHANTOM, RelicData.Part.WEAPON_PENUMBRAE, RelicData.Step.DEMIATMA, RelicData.Task.TASK_4],
				jobs: jobLists.relic[RelicData.Group.WEAPON_PHANTOM],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.CAPUT_MORTUUM_DEMIATMA]: {
		name: GameData.Item.CAPUT_MORTUUM_DEMIATMA,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			duties: {
				fates: [GameData.MapLocation.OCCULT_SOUTH_HORN, GameData.MapLocation.HERITAGE_FOUND],
				trials: [GameData.MapLocation.OCCULT_SOUTH_HORN],
			},
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_PHANTOM, RelicData.Part.WEAPON_PENUMBRAE, RelicData.Step.DEMIATMA, RelicData.Task.TASK_5],
				jobs: jobLists.relic[RelicData.Group.WEAPON_PHANTOM],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.ORPIMENT_DEMIATMA]: {
		name: GameData.Item.ORPIMENT_DEMIATMA,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			duties: {
				fates: [GameData.MapLocation.OCCULT_SOUTH_HORN, GameData.MapLocation.LIVING_MEMORY],
				trials: [GameData.MapLocation.OCCULT_SOUTH_HORN],
			},
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_PHANTOM, RelicData.Part.WEAPON_PENUMBRAE, RelicData.Step.DEMIATMA, RelicData.Task.TASK_6],
				jobs: jobLists.relic[RelicData.Group.WEAPON_PHANTOM],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.ARCANITE]: {
		name: GameData.Item.ARCANITE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "584914c9397",
		obtained: {
			shops: [
				{ shop: GameData.Shop.ERMINA, cost: [{ price: 500, currency: GameData.Currency.TOMESTONE_HIGH }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_PHANTOM, RelicData.Part.WEAPON_PENUMBRAE, RelicData.Step.ARCANITE, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_PHANTOM],
				qtyPerJob: 3,
			},
		],
	},
	[GameData.Item.COSMIC_DATA_I]: {
		name: GameData.Item.COSMIC_DATA_I,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { other: [{ element: "p", text: "Complete Cosmic Exploration Activities" }] },
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_COSMIC, RelicData.Step.PROTOTYPE_02, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 200,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_COSMIC, RelicData.Step.PROTOTYPE_03, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 500,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_COSMIC, RelicData.Step.PROTOTYPE_04, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 700,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_COSMIC, RelicData.Step.PROTOTYPE_05, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 1000,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_COSMIC, RelicData.Step.PROTOTYPE_06, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 1300,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_COSMIC, RelicData.Step.PROTOTYPE_07, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 1700,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_COSMIC, RelicData.Step.PROTOTYPE_08, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 2200,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_COSMIC, RelicData.Step.COSMIC, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 2800,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STELLAR, RelicData.Step.COSMIC_11, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 3000,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STELLAR, RelicData.Step.COSMIC_12, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 3450,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STELLAR, RelicData.Step.COSMIC_13, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 3900,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STELLAR, RelicData.Step.COSMIC_14, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 4300,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STELLAR, RelicData.Step.STELLAR, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 4700,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_HYPER, RelicData.Step.STELLAR11, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 5500,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_HYPER, RelicData.Step.STELLAR12, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 6300,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_HYPER, RelicData.Step.HYPER, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 7100,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STARS, RelicData.Step.HYPER11, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 7900,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STARS, RelicData.Step.HYPER12, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 8700,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STARS, RelicData.Step.STARS, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 9500,
			},
		],
	},
	[GameData.Item.COSMIC_DATA_II]: {
		name: GameData.Item.COSMIC_DATA_II,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { other: [{ element: "p", text: "Complete Cosmic Exploration Activities" }] },
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_COSMIC, RelicData.Step.PROTOTYPE_04, RelicData.Task.TASK_2],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 300,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_COSMIC, RelicData.Step.PROTOTYPE_05, RelicData.Task.TASK_2],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 800,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_COSMIC, RelicData.Step.PROTOTYPE_06, RelicData.Task.TASK_2],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 1200,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_COSMIC, RelicData.Step.PROTOTYPE_07, RelicData.Task.TASK_2],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 1700,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_COSMIC, RelicData.Step.PROTOTYPE_08, RelicData.Task.TASK_2],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 2300,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_COSMIC, RelicData.Step.COSMIC, RelicData.Task.TASK_2],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 2900,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STELLAR, RelicData.Step.COSMIC_11, RelicData.Task.TASK_2],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 3000,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STELLAR, RelicData.Step.COSMIC_12, RelicData.Task.TASK_2],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 3400,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STELLAR, RelicData.Step.COSMIC_13, RelicData.Task.TASK_2],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 3800,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STELLAR, RelicData.Step.COSMIC_14, RelicData.Task.TASK_2],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 4300,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STELLAR, RelicData.Step.STELLAR, RelicData.Task.TASK_2],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 4700,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_HYPER, RelicData.Step.STELLAR11, RelicData.Task.TASK_2],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 5500,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_HYPER, RelicData.Step.STELLAR12, RelicData.Task.TASK_2],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 6300,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_HYPER, RelicData.Step.HYPER, RelicData.Task.TASK_2],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 7100,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STARS, RelicData.Step.HYPER11, RelicData.Task.TASK_2],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 7900,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STARS, RelicData.Step.HYPER12, RelicData.Task.TASK_2],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 8700,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STARS, RelicData.Step.STARS, RelicData.Task.TASK_2],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 9500,
			},
		],
	},
	[GameData.Item.COSMIC_DATA_III]: {
		name: GameData.Item.COSMIC_DATA_III,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { other: [{ element: "p", text: "Complete Cosmic Exploration Activities" }] },
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_COSMIC, RelicData.Step.PROTOTYPE_06, RelicData.Task.TASK_3],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 500,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_COSMIC, RelicData.Step.PROTOTYPE_07, RelicData.Task.TASK_3],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 1100,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_COSMIC, RelicData.Step.PROTOTYPE_08, RelicData.Task.TASK_3],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 1700,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_COSMIC, RelicData.Step.COSMIC, RelicData.Task.TASK_3],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 2300,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STELLAR, RelicData.Step.COSMIC_11, RelicData.Task.TASK_3],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 3000,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STELLAR, RelicData.Step.COSMIC_12, RelicData.Task.TASK_3],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 3250,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STELLAR, RelicData.Step.COSMIC_13, RelicData.Task.TASK_3],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 3650,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STELLAR, RelicData.Step.COSMIC_14, RelicData.Task.TASK_3],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 4150,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STELLAR, RelicData.Step.STELLAR, RelicData.Task.TASK_3],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 4700,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_HYPER, RelicData.Step.STELLAR11, RelicData.Task.TASK_3],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 5500,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_HYPER, RelicData.Step.STELLAR12, RelicData.Task.TASK_3],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 6300,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_HYPER, RelicData.Step.HYPER, RelicData.Task.TASK_3],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 7100,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STARS, RelicData.Step.HYPER11, RelicData.Task.TASK_3],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 7900,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STARS, RelicData.Step.HYPER12, RelicData.Task.TASK_3],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 8700,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STARS, RelicData.Step.STARS, RelicData.Task.TASK_3],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 9500,
			},
		],
	},
	[GameData.Item.COSMIC_DATA_IV]: {
		name: GameData.Item.COSMIC_DATA_IV,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { other: [{ element: "p", text: "Complete Cosmic Exploration Activities" }] },
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_COSMIC, RelicData.Step.PROTOTYPE_08, RelicData.Task.TASK_4],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 700,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_COSMIC, RelicData.Step.COSMIC, RelicData.Task.TASK_4],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 1500,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STELLAR, RelicData.Step.COSMIC_11, RelicData.Task.TASK_4],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 2000,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STELLAR, RelicData.Step.COSMIC_12, RelicData.Task.TASK_4],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 2250,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STELLAR, RelicData.Step.COSMIC_13, RelicData.Task.TASK_4],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 2650,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STELLAR, RelicData.Step.COSMIC_14, RelicData.Task.TASK_4],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 3200,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STELLAR, RelicData.Step.STELLAR, RelicData.Task.TASK_4],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 4000,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_HYPER, RelicData.Step.STELLAR11, RelicData.Task.TASK_4],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 4300,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_HYPER, RelicData.Step.STELLAR12, RelicData.Task.TASK_4],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 5500,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_HYPER, RelicData.Step.HYPER, RelicData.Task.TASK_4],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 7100,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STARS, RelicData.Step.HYPER11, RelicData.Task.TASK_4],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 7900,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STARS, RelicData.Step.HYPER12, RelicData.Task.TASK_4],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 8700,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STARS, RelicData.Step.STARS, RelicData.Task.TASK_4],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 9500,
			},
		],
	},
	[GameData.Item.COSMIC_DATA_V]: {
		name: GameData.Item.COSMIC_DATA_V,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { other: [{ element: "p", text: "Complete Cosmic Exploration Activities" }] },
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STELLAR, RelicData.Step.COSMIC_12, RelicData.Task.TASK_5],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 100,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STELLAR, RelicData.Step.COSMIC_13, RelicData.Task.TASK_5],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 400,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STELLAR, RelicData.Step.COSMIC_14, RelicData.Task.TASK_5],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 900,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STELLAR, RelicData.Step.STELLAR, RelicData.Task.TASK_5],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 1500,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_HYPER, RelicData.Step.STELLAR11, RelicData.Task.TASK_5],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 1800,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_HYPER, RelicData.Step.STELLAR12, RelicData.Task.TASK_5],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 2550,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_HYPER, RelicData.Step.HYPER, RelicData.Task.TASK_5],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 3150,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STARS, RelicData.Step.HYPER11, RelicData.Task.TASK_5],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 3950,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STARS, RelicData.Step.HYPER12, RelicData.Task.TASK_5],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 4750,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STARS, RelicData.Step.STARS, RelicData.Task.TASK_5],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 5600,
			},
		],
	},
	[GameData.Item.COSMIC_DATA_VI]: {
		name: GameData.Item.COSMIC_DATA_VI,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { other: [{ element: "p", text: "Complete Cosmic Exploration Activities" }] },
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_HYPER, RelicData.Step.STELLAR12, RelicData.Task.TASK_6],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 600,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_HYPER, RelicData.Step.HYPER, RelicData.Task.TASK_6],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 1600,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STARS, RelicData.Step.HYPER11, RelicData.Task.TASK_6],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 1900,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STARS, RelicData.Step.HYPER12, RelicData.Task.TASK_6],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 2300,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STARS, RelicData.Step.STARS, RelicData.Task.TASK_6],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 2700,
			},
		],
	},
	[GameData.Item.COSMIC_DATA_VII]: {
		name: GameData.Item.COSMIC_DATA_VII,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { other: [{ element: "p", text: "Complete Cosmic Exploration Activities" }] },
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STARS, RelicData.Step.HYPER12, RelicData.Task.TASK_7],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 600,
			},
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_COSMIC, RelicData.Part.TOOL_STARS, RelicData.Step.STARS, RelicData.Task.TASK_7],
				jobs: jobLists.relic[RelicData.Group.TOOL_COSMIC],
				qtyPerJob: 1600,
			},
		],
	},
	[GameData.Item.RRONEEK_GLUE]: {
		name: GameData.Item.RRONEEK_GLUE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.GOPLU, cost: [{ price: 300000, currency: GameData.Currency.GIL }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_PHANTOM, RelicData.Part.WEAPON_UMBRAE, RelicData.Step.UMBRAE_ITEMS, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_PHANTOM],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.UTOHMU_SIDERITE]: {
		name: GameData.Item.UTOHMU_SIDERITE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.RRAL_WURUQ, cost: [{ price: 600, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_PHANTOM, RelicData.Part.WEAPON_UMBRAE, RelicData.Step.UMBRAE_ITEMS, RelicData.Task.TASK_2],
				jobs: jobLists.relic[RelicData.Group.WEAPON_PHANTOM],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.SYNTHETIC_DARK_MATTER_ALPHA]: {
		name: GameData.Item.SYNTHETIC_DARK_MATTER_ALPHA,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.SYNTHETIC_DARK_MATTER_ALPHA,
					qtyMade: 1,
					crafter: Job.BSM,
					level: 100,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.OCTAHEDRITE, qty: 8 },
						{ item: GameData.Item.RAW_RHODOCHROSITE, qty: 4 },
						{ item: GameData.Item.LEVINCHROME_AETHERSAND, qty: 2 },
						{ item: GameData.Item.FIRE_CLUSTER, qty: 3 },
						{ item: GameData.Item.EARTH_CLUSTER, qty: 3 },
					],
				},
				{
					itemMade: GameData.Item.SYNTHETIC_DARK_MATTER_ALPHA,
					qtyMade: 1,
					crafter: Job.ARM,
					level: 100,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.OCTAHEDRITE, qty: 8 },
						{ item: GameData.Item.RAW_RHODOCHROSITE, qty: 4 },
						{ item: GameData.Item.LEVINCHROME_AETHERSAND, qty: 2 },
						{ item: GameData.Item.ICE_CLUSTER, qty: 3 },
						{ item: GameData.Item.EARTH_CLUSTER, qty: 3 },
					],
				},
				{
					itemMade: GameData.Item.SYNTHETIC_DARK_MATTER_ALPHA,
					qtyMade: 1,
					crafter: Job.GSM,
					level: 100,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.OCTAHEDRITE, qty: 8 },
						{ item: GameData.Item.RAW_RHODOCHROSITE, qty: 4 },
						{ item: GameData.Item.LEVINCHROME_AETHERSAND, qty: 2 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 3 },
						{ item: GameData.Item.FIRE_CLUSTER, qty: 3 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_PHANTOM, RelicData.Part.WEAPON_UMBRAE, RelicData.Step.UMBRAE_ITEMS, RelicData.Task.TASK_3],
				jobs: jobLists.relic[RelicData.Group.WEAPON_PHANTOM],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.SYNTHETIC_DARK_MATTER_BETA]: {
		name: GameData.Item.SYNTHETIC_DARK_MATTER_BETA,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.SYNTHETIC_DARK_MATTER_BETA,
					qtyMade: 1,
					crafter: Job.CRP,
					level: 100,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.CORDIA_LOG, qty: 4 },
						{ item: GameData.Item.COCHINEAL_PIGMENT, qty: 4 },
						{ item: GameData.Item.SHAALOANI_COFFEE, qty: 4 },
						{ item: GameData.Item.LEVINCHROME_AETHERSAND, qty: 2 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 3 },
						{ item: GameData.Item.ICE_CLUSTER, qty: 3 },
					],
				},
				{
					itemMade: GameData.Item.SYNTHETIC_DARK_MATTER_BETA,
					qtyMade: 1,
					crafter: Job.LTW,
					level: 100,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.CORDIA_LOG, qty: 4 },
						{ item: GameData.Item.COCHINEAL_PIGMENT, qty: 4 },
						{ item: GameData.Item.SHAALOANI_COFFEE, qty: 4 },
						{ item: GameData.Item.LEVINCHROME_AETHERSAND, qty: 2 },
						{ item: GameData.Item.EARTH_CLUSTER, qty: 3 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 3 },
					],
				},
				{
					itemMade: GameData.Item.SYNTHETIC_DARK_MATTER_BETA,
					qtyMade: 1,
					crafter: Job.WVR,
					level: 100,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.CORDIA_LOG, qty: 4 },
						{ item: GameData.Item.COCHINEAL_PIGMENT, qty: 4 },
						{ item: GameData.Item.SHAALOANI_COFFEE, qty: 4 },
						{ item: GameData.Item.LEVINCHROME_AETHERSAND, qty: 2 },
						{ item: GameData.Item.LIGHTNING_CLUSTER, qty: 3 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 3 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_PHANTOM, RelicData.Part.WEAPON_UMBRAE, RelicData.Step.UMBRAE_ITEMS, RelicData.Task.TASK_4],
				jobs: jobLists.relic[RelicData.Group.WEAPON_PHANTOM],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.SYNTHETIC_DARK_MATTER_GAMMA]: {
		name: GameData.Item.SYNTHETIC_DARK_MATTER_GAMMA,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.SYNTHETIC_DARK_MATTER_GAMMA,
					qtyMade: 1,
					crafter: Job.ALC,
					level: 100,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.FULGURITE, qty: 4 },
						{ item: GameData.Item.SHAALOANI_COFFEE, qty: 4 },
						{ item: GameData.Item.LEVINCHROME_AETHERSAND, qty: 2 },
						{ item: GameData.Item.WATER_CLUSTER, qty: 3 },
						{ item: GameData.Item.LIGHTNING_CLUSTER, qty: 3 },
					],
				},
				{
					itemMade: GameData.Item.SYNTHETIC_DARK_MATTER_GAMMA,
					qtyMade: 1,
					crafter: Job.CUL,
					level: 100,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.FULGURITE, qty: 4 },
						{ item: GameData.Item.SHAALOANI_COFFEE, qty: 4 },
						{ item: GameData.Item.LEVINCHROME_AETHERSAND, qty: 2 },
						{ item: GameData.Item.FIRE_CLUSTER, qty: 3 },
						{ item: GameData.Item.WATER_CLUSTER, qty: 3 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_PHANTOM, RelicData.Part.WEAPON_UMBRAE, RelicData.Step.UMBRAE_ITEMS, RelicData.Task.TASK_5],
				jobs: jobLists.relic[RelicData.Group.WEAPON_PHANTOM],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.AETHERWELL_GREEN]: {
		name: GameData.Item.AETHERWELL_GREEN,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { duties: { roulettes: [GameData.Roulette.HIGH_LEVEL] } },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_PHANTOM, RelicData.Part.WEAPON_UMBRAE, RelicData.Step.AETHERWELL, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_PHANTOM],
				qtyPerJob: 10000,
			},
		],
	},
	[GameData.Item.AETHERWELL_BLUE]: {
		name: GameData.Item.AETHERWELL_BLUE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { duties: { roulettes: [GameData.Roulette.AR] } },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_PHANTOM, RelicData.Part.WEAPON_UMBRAE, RelicData.Step.AETHERWELL, RelicData.Task.TASK_2],
				jobs: jobLists.relic[RelicData.Group.WEAPON_PHANTOM],
				qtyPerJob: 10000,
			},
		],
	},
	[GameData.Item.AETHERWELL_RED]: {
		name: GameData.Item.AETHERWELL_RED,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { duties: { roulettes: [GameData.Roulette.TRIALS] } },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_PHANTOM, RelicData.Part.WEAPON_UMBRAE, RelicData.Step.AETHERWELL, RelicData.Task.TASK_3],
				jobs: jobLists.relic[RelicData.Group.WEAPON_PHANTOM],
				qtyPerJob: 10000,
			},
		],
	},
	[GameData.Item.AETHERWELL_YELLOW]: {
		name: GameData.Item.AETHERWELL_YELLOW,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { duties: { roulettes: [GameData.Roulette.NR] } },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_PHANTOM, RelicData.Part.WEAPON_UMBRAE, RelicData.Step.AETHERWELL, RelicData.Task.TASK_4],
				jobs: jobLists.relic[RelicData.Group.WEAPON_PHANTOM],
				qtyPerJob: 10000,
			},
		],
	},
	[GameData.Item.WAXING_ARCANITE]: {
		name: GameData.Item.WAXING_ARCANITE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.ERMINA, cost: [{ price: 500, currency: GameData.Currency.TOMESTONE_HIGH }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_PHANTOM, RelicData.Part.WEAPON_UMBRAE, RelicData.Step.WAXING_ARCANITE, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_PHANTOM],
				qtyPerJob: 3,
			},
		],
	},
	[GameData.Item.UMBRAL_CLAY]: {
		name: GameData.Item.UMBRAL_CLAY,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.GOPLU, cost: [{ price: 300000, currency: GameData.Currency.GIL }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_PHANTOM, RelicData.Part.WEAPON_OBSCURUM, RelicData.Step.OBSCURUM_ITEMS, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_PHANTOM],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.ASPECTED_AETHEROCONDUCTOR]: {
		name: GameData.Item.ASPECTED_AETHEROCONDUCTOR,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ASPECTED_AETHEROCONDUCTOR,
					qtyMade: 1,
					crafter: Job.BSM,
					level: 100,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.DENSE_ALUMINUM_ORE, qty: 8 },
						{ item: GameData.Item.ROSE_GARNET_ORE, qty: 4 },
						{ item: GameData.Item.LEVINCHROME_AETHERSAND, qty: 2 },
						{ item: GameData.Item.FIRE_CLUSTER, qty: 3 },
						{ item: GameData.Item.EARTH_CLUSTER, qty: 3 },
					],
				},
				{
					itemMade: GameData.Item.ASPECTED_AETHEROCONDUCTOR,
					qtyMade: 1,
					crafter: Job.ARM,
					level: 100,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.DENSE_ALUMINUM_ORE, qty: 8 },
						{ item: GameData.Item.ROSE_GARNET_ORE, qty: 4 },
						{ item: GameData.Item.LEVINCHROME_AETHERSAND, qty: 2 },
						{ item: GameData.Item.ICE_CLUSTER, qty: 3 },
						{ item: GameData.Item.EARTH_CLUSTER, qty: 3 },
					],
				},
				{
					itemMade: GameData.Item.ASPECTED_AETHEROCONDUCTOR,
					qtyMade: 1,
					crafter: Job.GSM,
					level: 100,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.DENSE_ALUMINUM_ORE, qty: 8 },
						{ item: GameData.Item.ROSE_GARNET_ORE, qty: 4 },
						{ item: GameData.Item.LEVINCHROME_AETHERSAND, qty: 2 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 3 },
						{ item: GameData.Item.FIRE_CLUSTER, qty: 3 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_PHANTOM, RelicData.Part.WEAPON_OBSCURUM, RelicData.Step.OBSCURUM_ITEMS, RelicData.Task.TASK_2],
				jobs: jobLists.relic[RelicData.Group.WEAPON_PHANTOM],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.ASPECTED_AETHER_AGGLOMERATE]: {
		name: GameData.Item.ASPECTED_AETHER_AGGLOMERATE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ASPECTED_AETHER_AGGLOMERATE,
					qtyMade: 1,
					crafter: Job.CRP,
					level: 100,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.FULGURPINE_LOG, qty: 4 },
						{ item: GameData.Item.CARNAUBA_LEAF, qty: 4 },
						{ item: GameData.Item.URQOPACHA_FLAX, qty: 4 },
						{ item: GameData.Item.LEVINCHROME_AETHERSAND, qty: 2 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 3 },
						{ item: GameData.Item.ICE_CLUSTER, qty: 3 },
					],
				},
				{
					itemMade: GameData.Item.ASPECTED_AETHER_AGGLOMERATE,
					qtyMade: 1,
					crafter: Job.LTW,
					level: 100,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.FULGURPINE_LOG, qty: 4 },
						{ item: GameData.Item.CARNAUBA_LEAF, qty: 4 },
						{ item: GameData.Item.URQOPACHA_FLAX, qty: 4 },
						{ item: GameData.Item.LEVINCHROME_AETHERSAND, qty: 2 },
						{ item: GameData.Item.EARTH_CLUSTER, qty: 3 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 3 },
					],
				},
				{
					itemMade: GameData.Item.ASPECTED_AETHER_AGGLOMERATE,
					qtyMade: 1,
					crafter: Job.WVR,
					level: 100,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.FULGURPINE_LOG, qty: 4 },
						{ item: GameData.Item.CARNAUBA_LEAF, qty: 4 },
						{ item: GameData.Item.URQOPACHA_FLAX, qty: 4 },
						{ item: GameData.Item.LEVINCHROME_AETHERSAND, qty: 2 },
						{ item: GameData.Item.LIGHTNING_CLUSTER, qty: 3 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 3 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_PHANTOM, RelicData.Part.WEAPON_OBSCURUM, RelicData.Step.OBSCURUM_ITEMS, RelicData.Task.TASK_3],
				jobs: jobLists.relic[RelicData.Group.WEAPON_PHANTOM],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.ASPECTED_AETHEROCATALYST]: {
		name: GameData.Item.ASPECTED_AETHEROCATALYST,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ASPECTED_AETHEROCATALYST,
					qtyMade: 1,
					crafter: Job.ALC,
					level: 100,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.WINDSPATH_WATER, qty: 4 },
						{ item: GameData.Item.CARNAUBA_LEAF, qty: 4 },
						{ item: GameData.Item.LEVINCHROME_AETHERSAND, qty: 2 },
						{ item: GameData.Item.WATER_CLUSTER, qty: 3 },
						{ item: GameData.Item.LIGHTNING_CLUSTER, qty: 3 },
					],
				},
				{
					itemMade: GameData.Item.ASPECTED_AETHEROCATALYST,
					qtyMade: 1,
					crafter: Job.CUL,
					level: 100,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.WINDSPATH_WATER, qty: 4 },
						{ item: GameData.Item.CARNAUBA_LEAF, qty: 4 },
						{ item: GameData.Item.LEVINCHROME_AETHERSAND, qty: 2 },
						{ item: GameData.Item.FIRE_CLUSTER, qty: 3 },
						{ item: GameData.Item.WATER_CLUSTER, qty: 3 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_PHANTOM, RelicData.Part.WEAPON_OBSCURUM, RelicData.Step.OBSCURUM_ITEMS, RelicData.Task.TASK_4],
				jobs: jobLists.relic[RelicData.Group.WEAPON_PHANTOM],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.CRYSTAL_PASTE]: {
		name: GameData.Item.CRYSTAL_PASTE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			duties: {
				roulettes: [GameData.Roulette.EXPERT, GameData.Roulette.LEVEL_CAP, GameData.Roulette.LEVELING],
				fieldOperation: [GameData.FieldOperation.OC],
				deepDungeons: [GameData.DeepDungeon.PT],
				variant: [GameData.Variant.MERCHANTS_TALE, GameData.Variant.MERCHANTS_TALE_ADVANCED, GameData.Variant.ANOTHER_MERCHANTS_TALE],
				raids: [
					GameData.Raid.ARCADION_9,
					GameData.Raid.ARCADION_10,
					GameData.Raid.ARCADION_11,
					GameData.Raid.ARCADION_12,
					GameData.Raid.ARCADION_9S,
					GameData.Raid.ARCADION_10S,
					GameData.Raid.ARCADION_11S,
					GameData.Raid.ARCADION_12S,
				],
				fates: [GameData.MapLocation.URQOPACHA, GameData.MapLocation.KOZAMA_UKA, GameData.MapLocation.YAK_TEL, GameData.MapLocation.SHAALOANI, GameData.MapLocation.HERITAGE_FOUND, GameData.MapLocation.LIVING_MEMORY],
			},
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_PHANTOM, RelicData.Part.WEAPON_OBSCURUM, RelicData.Step.CRYSTAL_PASTE, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_PHANTOM],
				qtyPerJob: 1200,
			},
		],
	},
	[GameData.Item.WANING_ARCANITE]: {
		name: GameData.Item.WANING_ARCANITE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.ERMINA, cost: [{ price: 500, currency: GameData.Currency.TOMESTONE_HIGH }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_PHANTOM, RelicData.Part.WEAPON_OBSCURUM, RelicData.Step.WANING_ARCANITE, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_PHANTOM],
				qtyPerJob: 3,
			},
		],
	},
	[GameData.Item.MONARCH_WHETSTONE]: {
		name: GameData.Item.MONARCH_WHETSTONE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.GOPLU, cost: [{ price: 500000, currency: GameData.Currency.GIL }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_PHANTOM, RelicData.Part.WEAPON_ECLIPTICUM, RelicData.Step.ECLIPTICUM_ITEMS, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_PHANTOM],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.ANCESTRAL_ALLOY_INGOT]: {
		name: GameData.Item.ANCESTRAL_ALLOY_INGOT,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ANCESTRAL_ALLOY_INGOT,
					qtyMade: 1,
					crafter: Job.BSM,
					level: 100,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.DENSE_ALUMINUM_ORE, qty: 4 },
						{ item: GameData.Item.ROSE_GARNET_ORE, qty: 2 },
						{ item: GameData.Item.HARMONITE_ORE, qty: 4 },
						{ item: GameData.Item.FINE_SILVER_ORE, qty: 2 },
						{ item: GameData.Item.FIRE_CLUSTER, qty: 3 },
						{ item: GameData.Item.EARTH_CLUSTER, qty: 3 },
					],
				},
				{
					itemMade: GameData.Item.ANCESTRAL_ALLOY_INGOT,
					qtyMade: 1,
					crafter: Job.ARM,
					level: 100,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.DENSE_ALUMINUM_ORE, qty: 4 },
						{ item: GameData.Item.ROSE_GARNET_ORE, qty: 2 },
						{ item: GameData.Item.HARMONITE_ORE, qty: 4 },
						{ item: GameData.Item.FINE_SILVER_ORE, qty: 2 },
						{ item: GameData.Item.ICE_CLUSTER, qty: 3 },
						{ item: GameData.Item.EARTH_CLUSTER, qty: 3 },
					],
				},
				{
					itemMade: GameData.Item.ANCESTRAL_ALLOY_INGOT,
					qtyMade: 1,
					crafter: Job.GSM,
					level: 100,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.DENSE_ALUMINUM_ORE, qty: 4 },
						{ item: GameData.Item.ROSE_GARNET_ORE, qty: 2 },
						{ item: GameData.Item.HARMONITE_ORE, qty: 4 },
						{ item: GameData.Item.FINE_SILVER_ORE, qty: 2 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 3 },
						{ item: GameData.Item.FIRE_CLUSTER, qty: 3 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_PHANTOM, RelicData.Part.WEAPON_ECLIPTICUM, RelicData.Step.ECLIPTICUM_ITEMS, RelicData.Task.TASK_2],
				jobs: jobLists.relic[RelicData.Group.WEAPON_PHANTOM],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.ASCENDANT_TWINE]: {
		name: GameData.Item.ASCENDANT_TWINE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ASCENDANT_TWINE,
					qtyMade: 1,
					crafter: Job.CRP,
					level: 100,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.FULGURPINE_LOG, qty: 2 },
						{ item: GameData.Item.CARNAUBA_LEAF, qty: 2 },
						{ item: GameData.Item.URQOPACHA_FLAX, qty: 2 },
						{ item: GameData.Item.IPE_LOG, qty: 2 },
						{ item: GameData.Item.TURALI_ALUMEN, qty: 2 },
						{ item: GameData.Item.BLACKSEED_COTTON_BOLL, qty: 2 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 3 },
						{ item: GameData.Item.ICE_CLUSTER, qty: 3 },
					],
				},
				{
					itemMade: GameData.Item.ASCENDANT_TWINE,
					qtyMade: 1,
					crafter: Job.LTW,
					level: 100,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.FULGURPINE_LOG, qty: 2 },
						{ item: GameData.Item.CARNAUBA_LEAF, qty: 2 },
						{ item: GameData.Item.URQOPACHA_FLAX, qty: 2 },
						{ item: GameData.Item.IPE_LOG, qty: 2 },
						{ item: GameData.Item.TURALI_ALUMEN, qty: 2 },
						{ item: GameData.Item.BLACKSEED_COTTON_BOLL, qty: 2 },
						{ item: GameData.Item.EARTH_CLUSTER, qty: 3 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 3 },
					],
				},
				{
					itemMade: GameData.Item.ASCENDANT_TWINE,
					qtyMade: 1,
					crafter: Job.WVR,
					level: 100,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.FULGURPINE_LOG, qty: 2 },
						{ item: GameData.Item.CARNAUBA_LEAF, qty: 2 },
						{ item: GameData.Item.URQOPACHA_FLAX, qty: 2 },
						{ item: GameData.Item.IPE_LOG, qty: 2 },
						{ item: GameData.Item.TURALI_ALUMEN, qty: 2 },
						{ item: GameData.Item.BLACKSEED_COTTON_BOLL, qty: 2 },
						{ item: GameData.Item.LIGHTNING_CLUSTER, qty: 3 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 3 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_PHANTOM, RelicData.Part.WEAPON_ECLIPTICUM, RelicData.Step.ECLIPTICUM_ITEMS, RelicData.Task.TASK_3],
				jobs: jobLists.relic[RelicData.Group.WEAPON_PHANTOM],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.MAJESTIC_POLISH]: {
		name: GameData.Item.MAJESTIC_POLISH,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.MAJESTIC_POLISH,
					qtyMade: 1,
					crafter: Job.ALC,
					level: 100,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.WINDSPATH_WATER, qty: 2 },
						{ item: GameData.Item.CARNAUBA_LEAF, qty: 2 },
						{ item: GameData.Item.NOPALIFLOWER, qty: 4 },
						{ item: GameData.Item.WATER_CLUSTER, qty: 3 },
						{ item: GameData.Item.LIGHTNING_CLUSTER, qty: 3 },
					],
				},
				{
					itemMade: GameData.Item.MAJESTIC_POLISH,
					qtyMade: 1,
					crafter: Job.ALC,
					level: 100,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.WINDSPATH_WATER, qty: 2 },
						{ item: GameData.Item.CARNAUBA_LEAF, qty: 2 },
						{ item: GameData.Item.NOPALIFLOWER, qty: 4 },
						{ item: GameData.Item.FIRE_CLUSTER, qty: 3 },
						{ item: GameData.Item.WATER_CLUSTER, qty: 3 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_PHANTOM, RelicData.Part.WEAPON_ECLIPTICUM, RelicData.Step.ECLIPTICUM_ITEMS, RelicData.Task.TASK_4],
				jobs: jobLists.relic[RelicData.Group.WEAPON_PHANTOM],
				qtyPerJob: 1,
			},
		],
	},
	[GameData.Item.PHANTOM_DISPELLER_ALPHA]: {
		name: GameData.Item.PHANTOM_DISPELLER_ALPHA,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			duties: {
				fieldOperation: [GameData.FieldOperation.OCN],
				roulettes: [GameData.Roulette.HIGH_LEVEL],
			},
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_PHANTOM, RelicData.Part.WEAPON_ECLIPTICUM, RelicData.Step.PHANTOM_DISPELLER, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_PHANTOM],
				qtyPerJob: 100,
			},
		],
	},
	[GameData.Item.PHANTOM_DISPELLER_BETA]: {
		name: GameData.Item.PHANTOM_DISPELLER_BETA,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			duties: {
				fieldOperation: [GameData.FieldOperation.OCN],
				roulettes: [GameData.Roulette.TRIALS],
			},
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_PHANTOM, RelicData.Part.WEAPON_ECLIPTICUM, RelicData.Step.PHANTOM_DISPELLER, RelicData.Task.TASK_2],
				jobs: jobLists.relic[RelicData.Group.WEAPON_PHANTOM],
				qtyPerJob: 100,
			},
		],
	},
	[GameData.Item.PHANTOM_DISPELLER_GAMMA]: {
		name: GameData.Item.PHANTOM_DISPELLER_GAMMA,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			duties: {
				fieldOperation: [GameData.FieldOperation.OCN],
				roulettes: [GameData.Roulette.NR],
			},
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_PHANTOM, RelicData.Part.WEAPON_ECLIPTICUM, RelicData.Step.PHANTOM_DISPELLER, RelicData.Task.TASK_3],
				jobs: jobLists.relic[RelicData.Group.WEAPON_PHANTOM],
				qtyPerJob: 100,
			},
		],
	},
	[GameData.Item.ECLIPTIC_ARCANITE]: {
		name: GameData.Item.ECLIPTIC_ARCANITE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.ERMINA, cost: [{ price: 500, currency: GameData.Currency.TOMESTONE_HIGH }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_PHANTOM, RelicData.Part.WEAPON_ECLIPTICUM, RelicData.Step.ECLIPTIC_ARCANITE, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_PHANTOM],
				qtyPerJob: 3,
			},
		],
	},
	[GameData.Item.OCTAHEDRITE]: {
		name: GameData.Item.OCTAHEDRITE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ method: GameData.GatherMethod.MINING, found: { location: GameData.MapLocation.CERULEAN_CEXUDROSS, x: 17, y: 36 } }] },
		used: [],
	},
	[GameData.Item.RAW_RHODOCHROSITE]: {
		name: GameData.Item.RAW_RHODOCHROSITE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ method: GameData.GatherMethod.QUARRYING, found: { location: GameData.MapLocation.UYUYUB, x: 12, y: 17 } }] },
		used: [],
	},
	[GameData.Item.LEVINCHROME_AETHERSAND]: {
		name: GameData.Item.LEVINCHROME_AETHERSAND,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RHALGRS_REACH, cost: [{ price: 300, currency: GameData.Currency.SCRIP_END_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RADZ_AT_HAN, cost: [{ price: 300, currency: GameData.Currency.SCRIP_END_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_EULMORE, cost: [{ price: 300, currency: GameData.Currency.SCRIP_END_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_MOR_DHONA, cost: [{ price: 300, currency: GameData.Currency.SCRIP_END_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_IDYLLSHIRE, cost: [{ price: 300, currency: GameData.Currency.SCRIP_END_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_ULDAH, cost: [{ price: 300, currency: GameData.Currency.SCRIP_END_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_SHARLAYAN, cost: [{ price: 300, currency: GameData.Currency.SCRIP_END_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_GRIDANIA, cost: [{ price: 300, currency: GameData.Currency.SCRIP_END_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_CRYSTARIUM, cost: [{ price: 300, currency: GameData.Currency.SCRIP_END_GATHERER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_LIMSA, cost: [{ price: 300, currency: GameData.Currency.SCRIP_END_GATHERER }] },
				{ shop: GameData.Shop.MESOUAIDONQUE_AUXESIA, cost: [{ price: 600, currency: GameData.Currency.COSMO_CREDIT }] },
				{ shop: GameData.Shop.MESOUAIDONQUE_OIZYS, cost: [{ price: 600, currency: GameData.Currency.COSMO_CREDIT }] },
				{ shop: GameData.Shop.MESOUAIDONQUE_PHAENNA, cost: [{ price: 600, currency: GameData.Currency.COSMO_CREDIT }] },
				{ shop: GameData.Shop.MESOUAIDONQUE_SINUS_ARDORUM, cost: [{ price: 600, currency: GameData.Currency.COSMO_CREDIT }] },
			],
		},
		used: [],
	},
	[GameData.Item.CORDIA_LOG]: {
		name: GameData.Item.CORDIA_LOG,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ method: GameData.GatherMethod.LOGGING, found: { location: GameData.MapLocation.XOBRIT_CINDERFIELD, x: 35, y: 22 } }] },
		used: [],
	},
	[GameData.Item.COCHINEAL_PIGMENT]: {
		name: GameData.Item.COCHINEAL_PIGMENT,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ method: GameData.GatherMethod.LOGGING, found: { location: GameData.MapLocation.EAST_YYASULANI, x: 34, y: 20 } }] },
		used: [],
	},
	[GameData.Item.SHAALOANI_COFFEE]: {
		name: GameData.Item.SHAALOANI_COFFEE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ method: GameData.GatherMethod.HARVESTING, found: { location: GameData.MapLocation.PYARIYOANAAN_PLAIN, x: 34, y: 15 } }] },
		used: [],
	},
	[GameData.Item.FULGURITE]: {
		name: GameData.Item.FULGURITE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ method: GameData.GatherMethod.QUARRYING, found: { location: GameData.MapLocation.EVERKEEP_WARD, x: 13, y: 16 } }] },
		used: [],
	},
	[GameData.Item.DENSE_ALUMINUM_ORE]: {
		name: GameData.Item.DENSE_ALUMINUM_ORE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ method: GameData.GatherMethod.MINING, found: { location: GameData.MapLocation.ARCHEO_ALEXANDRIA, x: 23, y: 27 } }] },
		used: [],
	},
	[GameData.Item.ROSE_GARNET_ORE]: {
		name: GameData.Item.ROSE_GARNET_ORE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ method: GameData.GatherMethod.QUARRYING, found: { location: GameData.MapLocation.YAWTANANE_GRASSLANDS, x: 23, y: 27 } }] },
		used: [],
	},
	[GameData.Item.FULGURPINE_LOG]: {
		name: GameData.Item.FULGURPINE_LOG,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ method: GameData.GatherMethod.LOGGING, found: { location: GameData.MapLocation.KNOWABLE, x: 8, y: 9 } }] },
		used: [],
	},
	[GameData.Item.CARNAUBA_LEAF]: {
		name: GameData.Item.CARNAUBA_LEAF,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ method: GameData.GatherMethod.LOGGING, found: { location: GameData.MapLocation.UYUYUB, x: 14, y: 10 } }] },
		used: [],
	},
	[GameData.Item.URQOPACHA_FLAX]: {
		name: GameData.Item.URQOPACHA_FLAX,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ method: GameData.GatherMethod.HARVESTING, found: { location: GameData.MapLocation.LARH_TORTOH, x: 5, y: 25 } }] },
		used: [],
	},
	[GameData.Item.WINDSPATH_WATER]: {
		name: GameData.Item.WINDSPATH_WATER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ method: GameData.GatherMethod.MINING, found: { location: GameData.MapLocation.KNOWABLE, x: 8, y: 14 } }] },
		used: [],
	},
	[GameData.Item.HARMONITE_ORE]: {
		name: GameData.Item.HARMONITE_ORE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ method: GameData.GatherMethod.MINING, found: { location: GameData.MapLocation.KNOWABLE, x: 9, y: 15 } }] },
		used: [],
	},
	[GameData.Item.FINE_SILVER_ORE]: {
		name: GameData.Item.FINE_SILVER_ORE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ method: GameData.GatherMethod.MINING, found: { location: GameData.MapLocation.YAWTANANE_GRASSLANDS, x: 37, y: 28 } }] },
		used: [],
	},
	[GameData.Item.IPE_LOG]: {
		name: GameData.Item.IPE_LOG,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ method: GameData.GatherMethod.LOGGING, found: { location: GameData.MapLocation.DEWSPUN_BANK, x: 7, y: 33 } }] },
		used: [],
	},
	[GameData.Item.TURALI_ALUMEN]: {
		name: GameData.Item.TURALI_ALUMEN,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ method: GameData.GatherMethod.QUARRYING, found: { location: GameData.MapLocation.NARYOR_GORNA, x: 37, y: 30 } }] },
		used: [],
	},
	[GameData.Item.BLACKSEED_COTTON_BOLL]: {
		name: GameData.Item.BLACKSEED_COTTON_BOLL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ method: GameData.GatherMethod.HARVESTING, found: { location: GameData.MapLocation.ARENA_OF_VALOR, x: 28, y: 17 } }] },
		used: [],
	},
	[GameData.Item.NOPALIFLOWER]: {
		name: GameData.Item.NOPALIFLOWER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ method: GameData.GatherMethod.LOGGING, found: { location: GameData.MapLocation.YAWTANANE_GRASSLANDS, x: 11, y: 31 } }] },
		used: [],
	},
} satisfies Partial<{ [key in GameData.Item]: Info.Item }>;
